import { render, staticRenderFns } from "./MyStudyCourse.vue?vue&type=template&id=2fab5142&scoped=true&"
import script from "./MyStudyCourse.vue?vue&type=script&lang=js&"
export * from "./MyStudyCourse.vue?vue&type=script&lang=js&"
import style0 from "./MyStudyCourse.vue?vue&type=style&index=0&id=2fab5142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab5142",
  null
  
)

export default component.exports